import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../../../helpers/stateHelpers';

const errorRequestReducer = handleActions({
  [types.API_REQUEST]: mergeIn(action => action.payload),
}, null);

export default errorRequestReducer;
